import { render } from "./MeetappPricingDetails.vue?vue&type=template&id=b4d70028&scoped=true&ts=true"
import script from "./MeetappPricingDetails.vue?vue&type=script&lang=ts"
export * from "./MeetappPricingDetails.vue?vue&type=script&lang=ts"

import "./MeetappPricingDetails.vue?vue&type=style&index=0&id=b4d70028&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4d70028"]])

export default __exports__